import z from 'zod'

import { entitySchema, timestampSchema } from '@/utility/utility'

/** GitHub user data stored for doing publishes */
export const userGithubSchema = entitySchema
  .extend({
    token: z.string(),
    refreshToken: z.string(),
    expiry: timestampSchema,
    refreshExpiry: timestampSchema,
  })
  .meta({ id: 'user-github' })

export type UserGithub = z.infer<typeof userGithubSchema>
